<template>
  <div>
    <div dir="rtl">
      <label>צבע : </label>
      <select
        v-model="offerStatus.color"
      >
        <option value="remove_filter">NOT SELECTED</option>
        <option
          v-for="(option, idx) in ['red', 'orange', 'green', 'purple']"
          :key="idx"
          :value="option"
          >{{ option }}</option
        >
      </select>
    </div>
    <div class="modal_footer">
      <a
        @click="submit(true)"
        :class="{ 'is-loading': is_submitting }"
        class="button is-info is-rounded"
        >הזן ורענן לי את הדף</a
      >
      <a
        @click="submit(false)"
        :class="{ 'is-loading': is_submitting }"
        class="button is-info is-rounded"
        style="margin: 10px"
        >הזן ואל תרענן</a
      >
    </div>
  </div>
</template>
<script>
// libraries
import { mapActions } from 'vuex'

export default {
  name: 'admin-offer-color-form',
  props: ['payload'],
  data () {
    return {
      offerStatus: {},
      is_submitting: false
    }
  },
  async created () {
    try {
      const r = await this.$network_utils.getOfferStatus({
        id: this.payload.data.id
      })
      this.offerStatus = r
    } catch (e) {
      console.log(e)
    }
  },
  methods: {
    ...mapActions('offerStatuses', ['fetchOfferStatuses']),
    async submit (refresh) {
      try {
        const r = await this.$network_utils.updateOfferStatuses(this.offerStatus)
        if (refresh) {
          this.fetchOfferStatuses()
        }
        this.$utils.emit('show_toast', {
          text: `Success: You successfully updated the following tag: ${r.var}`
        })
      } catch (e) {
        this.$utils.emit('show_toast', { text: `Error: try again` })
        console.error(e)
      }
    }
  }
}
</script>
